import { render, staticRenderFns } from "./CheckoutsFilter.vue?vue&type=template&id=50a3e106&"
import script from "./CheckoutsFilter.vue?vue&type=script&lang=js&"
export * from "./CheckoutsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports